<template>
  <div
    v-editable="blok"
    class="departments-banner"
  >
    <div class="mobile">
      <NuxtImg
        provider="storyblok"
        :src="department.heroImage.filename"
        :alt="department.heroImage.alt"
        sizes="xs:100vw sm:100vw md:768px"
        loading="lazy"
        format="webp"
      />
    </div>
    <div class="desktop">
      <div
        v-for="(team, index) in blok.content"
        :key="index"
        class="department"
      >
        <div class="department__image">
          <NuxtImg
            provider="storyblok"
            :src="team.content.heroImage.filename"
            :alt="team.content.heroImage.alt"
            loading="lazy"
            width="280"
            height="210"
            format="webp"
          />
        </div>
        <div class="department__title">
          <NuxtLink
            :to="`/${locale}${formatSbPath(team.full_slug, locale)}`"
            @click="setActiveTeam(team.slug)"
          >
            <h4>{{ team.content.title }}</h4>
          </NuxtLink>
          <div class="separator" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import formatSbPath from '@/utils/formatSbPath'
  import { useTeamsStore } from '@/stores/teams.store'

  defineProps<{
    blok: any
    department: {
      heroImage: {
        filename: string
        alt: string
      }
    }
  }>()

  const { locale } = useI18n()

  const teamStore = useTeamsStore()
  const setActiveTeam = (team: string) => {
    teamStore.activeTeam = team
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .departments-banner {
    max-width: 1120px;
    margin: auto;

    .mobile {
      @include tablet-up {
        display: none;
      }

      img {
        height: auto;
        object-fit: cover;
        width: 100%;
      }
    }

    .desktop {
      display: none;

      @include tablet-up {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
      }

      .department {
        // TODO: Fix 1px space
        position: relative;

        &__image {
          img {
            width: 100%;
            height: auto;
          }
        }

        &__title {
          background-color: rgba($ui-dark-blue, 0.8);
          bottom: 1px;
          color: $white;
          position: absolute;
          text-align: center;

          @include tablet-up {
            padding: rem(12);
            width: calc(100% - 24px);
          }

          h4 {
            color: $white;
            margin: 0;
          }

          .separator {
            margin: rem(8) auto;
            max-width: 75%;
          }
        }
      }
    }
  }
</style>
